<template>
  <div class="chat-input text-center w-100" :class="getInputClass()">
    <div class="d-flex align-items-center p-2">
      <button class="mr-1 attach" :class="getAttachButtonClass()">
        <img :src="`${publicPath}/img/rcp/icon/attach.png`" />
        <FileComponent
          @file-updated="captureFile($event)"
          :key="'file'"
        ></FileComponent>
      </button>
      <textarea
        v-model="newMessage"
        @keydown.enter.prevent="sendMessage"
        :placeholder="`${$t('Write text here')}...`"
        :class="getTextareaClass()"
      >
      </textarea>
      <button @click="sendMessage" class="btn" :class="getSendButtonClass()">
        <img :src="`${publicPath}/img/rcp/icon/cs-send.png`" />
      </button>
    </div>
  </div>
</template>

<script>
import FileComponent from "@/components/FileComponent";

export default {
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      newMessage: "",
    };
  },
  props: ["isPartnerMode"],
  components: {
    FileComponent,
  },
  methods: {
    captureFile($event) {
      this.$emit("capture-file", $event);
    },
    sendMessage() {
      if (this.newMessage) {
        this.$emit("send-message", this.newMessage);
        this.newMessage = "";
      }
    },

    // Partner mode class methods (mengikuti style PartnerProfile.vue)
    getInputClass() {
      return this.isPartnerMode ? "" : "";
    },

    getAttachButtonClass() {
      return this.isPartnerMode ? "" : "";
    },

    getTextareaClass() {
      return this.isPartnerMode ? "enhanced-form-control" : "";
    },

    getSendButtonClass() {
      return this.isPartnerMode ? "btn-primary" : "bg-upload-payment";
    },
  },
  mounted: function () {
    this.message = "";
  },
};
</script>

<style scoped src="@/assets/css/chat.css"></style>
